module.exports = __webpack_public_path__ + "static/media/dialog_zilant.f44aaf5d.png";